import { Form, FormProps } from 'antd';
import { memo, ReactNode } from 'react';
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';
import { z, ZodTypeAny } from 'zod';
// import CustomizeRequiredMark from '../CustomizeRequiredMark';
import classNames from 'classnames';
import { SchemaProvider } from '../../hooks/useFormSchema';
import './styles.scss';

export type CustomRequiredMarkFormProps<FV extends FieldValues> = FormProps & {
  methods: UseFormReturn<FV>;
  schema?: ZodTypeAny;
};

const CustomRequiredMarkForm = <FV extends FieldValues>(
  props: CustomRequiredMarkFormProps<FV>,
) => {
  const {
    schema,
    methods,
    children,
    className,
    layout = 'vertical',
    ...rest
  } = props;

  return (
    <SchemaProvider schema={schema ?? z.object({})}>
      <FormProvider {...methods}>
        <Form
          layout={layout}
          {...rest}
          className={classNames(className, 'custom-required-mark-form')}
        >
          {children as ReactNode}
        </Form>
      </FormProvider>
    </SchemaProvider>
  );
};

export default memo(CustomRequiredMarkForm) as typeof CustomRequiredMarkForm;
